import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth } from '@angular/fire/auth';
import { AuthService } from '../services/auth.service';

/**
 * Only checks the user is signed in — genuinely generic, not B2B-specific despite guarding
 * `/business` (renamed from businessGuard 2026-09-01 to also cover `/profile`, which has the
 * identical requirement — no reason to duplicate the same 15 lines a third time).
 *
 * For `/business` specifically: this can't also check "is this actually a Business (B2B)
 * customer" — `customerType` isn't a Firebase custom claim (deliberately, same as the `role`
 * claim isn't mirrored into Postgres — see CLAUDE.md) and isn't cached anywhere client-side after
 * the one-time `bootstrap()` response. `GET /api/customers/me` now exists (2026-09-01), making
 * this upgrade newly possible, but wiring it in is a deliberate follow-up, not done here — it
 * would add a network round-trip to every `/business` navigation.
 */
export const authGuard: CanActivateFn = async (_route, state) => {
  const auth = inject(Auth);
  const authService = inject(AuthService);
  const router = inject(Router);

  await auth.authStateReady();

  const user = authService.currentUser();
  if (!user) {
    return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
  }

  return true;
};
